<template>
  <div>
    <div class="mark">
      <img src="@/assets/images/exclamatoryMark.png" alt="" class="QRcodeIcon" />
    </div>
    <p class="warn">补充资料</p>
    <div class="tip">
      <p class="text">您有待补充的资料，请尽快完成。</p>
      <p class="text">详情：{{orderInfo.refuseInfo}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Toast } from 'vant';

export default {
  name: 'supplementaryInformation',
  data() {
    return {
      num: 0,
      orderInfo: {},
    };
  },
  mounted() {
    // 后端进行跳转
    this.jumpCurrPage();

    // 获取订单信息
    this.getInformation();
  },
  methods: {
    jumpCurrPage() {
      const oldNum = this.num;
      const orderId = this.$route.query.orderId || this.commonForms.orderId || localStorage.getItem('orderId');
      if (oldNum < 6) {
        this.num = oldNum + 1;
        this.$api.PublicPage.jumpCurrPage({
          orderId,
        })
          .then((res) => {
            if (res.success) { 
              if (res.data) {
                window.location.href = res.data;
              } else {
                setTimeout(
                  () => this.jumpCurrPage(), 5000,
                );
              }
            } else {
              setTimeout(
                () => this.jumpCurrPage(), 5000,
              );
            }
          });
      }
    },
    getInformation() {
      const orderId = this.$route.query.orderId || this.commonForms.orderId || localStorage.getItem('orderId');
      this.$api.CommonForms.getOrderStatus({ orderId }).then((res) => {
        if (res && res.success) {
          console.log(res.data, '==data');
          this.orderInfo = res.data;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },
};
</script>
<style scoped lang="scss">
.mark {
  margin-top: 103px;
  .QRcodeIcon {
    width: 60px;
    height: 60px;
  }
}
.warn {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1C2438;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 0;
}
.tip {
  width: calc(100% - 30px);
  height: 60px;
  margin: 0 auto;
  color: #9ea7b4;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
  .text {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #9EA7B4;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin: 0;
  }
}

</style>
